var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUrinary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#337a10",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 151.952 151.952",
    xmlSpace: "preserve",
    stroke: "#337a10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.699,5.978c-14.63-12.186-24.597-2.889-29.202,2.818c-6.01,7.442-3.151,18.017,0.332,22.386 c2.222,2.78,3.734,5.218,4.739,7.398c-2.059,0.402-4.441,1.278-6.949,3.059c-9.057,6.438-15.289,21.024-18.641,43.566 c-3.356-22.542-9.581-37.128-18.637-43.566c-2.509-1.789-4.884-2.662-6.952-3.064c1.006-2.181,2.509-4.613,4.739-7.393 c3.479-4.369,6.344-14.944,0.336-22.386C50.854,3.089,40.89-6.208,26.259,5.978C14.089,16.121-3.864,46.462,13.116,68.02 c5.591,7.095,19.577,16.692,36.081,1.428c0,0,8.667-9.513,2.059-17.831c-1.23-1.551-2.178-3.374-2.418-5.589 c1.232,0.221,2.706,0.7,4.414,1.981c5.02,3.762,12.136,14.223,15.761,42.536c-8.208,2.02-14.131,7.453-14.131,13.894 c0,6.981,6.938,12.811,16.227,14.358c0.276,8.722,0.332,18.348,0.036,29.28l-0.101,3.875h9.848l-0.101-3.875 c-0.295-10.922-0.239-20.559,0.035-29.28c9.278-1.537,16.222-7.365,16.222-14.358c0-6.44-5.92-11.874-14.126-13.894 c3.626-28.313,10.756-38.769,15.762-42.536c1.719-1.281,3.196-1.771,4.416-1.989c-0.238,2.224-1.176,4.052-2.418,5.604 c-6.608,8.312,2.058,17.83,2.058,17.83c16.506,15.264,30.49,5.667,36.084-1.428C155.823,46.462,137.87,16.121,125.699,5.978z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrinary);
export default __webpack_public_path__ + "static/media/urinary.2ad2b96e195b753400f464f9dbb5de04.svg";
export { ForwardRef as ReactComponent };